import { render, staticRenderFns } from "./EstadoProcesoSettings.vue?vue&type=template&id=249ee96d&scoped=true"
import script from "./EstadoProcesoSettings.vue?vue&type=script&lang=js"
export * from "./EstadoProcesoSettings.vue?vue&type=script&lang=js"
import style0 from "./EstadoProcesoSettings.vue?vue&type=style&index=0&id=249ee96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ee96d",
  null
  
)

export default component.exports